import { configureStore } from "@reduxjs/toolkit";
import bookmarkReducer from "../features/bookmark/bookmarkSlice";
import resourceBookmarksReducer from "../features/bookmark/resourceBookmarksSlice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

export const store = configureStore({
  reducer: {
    bookmark: bookmarkReducer,
    resourceBookmarks: resourceBookmarksReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
